import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import useIsPaymentOverdueBannerVisible from 'components/hooks/use_is_payment_overdue_banner_visible';

export default function PaymentOverdueBanner() {
  if (!useIsPaymentOverdueBannerVisible()) return null;

  return (
    <Container>
      <Content>
        <Message>
          <Trans
            components={{ contactLink: <a href="mailto:ar@gladly.com" /> }}
            i18nKey="Your account is past due. Please contact <contactLink>ar@gladly.com</contactLink> to remit payment and ensure uninterrupted access to Gladly."
          />
        </Message>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  background: ${({ theme }) => theme.colors.yellow100};
  z-index: 1000;
  display: flex;
`;

const Content = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Message = styled.div``;
